import axios from 'axios';

/*
*  This file contains all axios calls related export xml
*/

export const getXmlFromIdVersion = async (revisionId) => {
    const { data } = await axios.get(`/app/funnel/revision/${revisionId}/xml`);

    return data;
};

export const mapRevisionsInfoToRevisionsList = async (revisions) => {
    return Object.entries(revisions).map((entry) => {
        return { value: entry[0], label: entry[1] };
    });
};
